import React, { createRef, useCallback } from 'react';
import { Tappable } from '@vectord/components';
import classNames from 'classnames';

import Input from 'components/Input';
import styles from './FileSelect.module.scss';

export default function FileSelect({ className, children, onChange, accept }) {
  const fileSelector = createRef();

  const handleClick = useCallback(() => {
    fileSelector.current.click();
  }, [fileSelector]);

  const onFileChange = useCallback(
    (event) => {
      onChange(event.target.files);
    },
    [onChange]
  );

  return (
    <Tappable
      className={classNames(styles.fileSelectInput, className)}
      onClick={handleClick}
      role="presentation"
    >
      <Input
        type="file"
        ref={fileSelector}
        accept={accept}
        onChange={onFileChange}
        hidden
      />
      {children}
    </Tappable>
  );
}
